import { GridWrapper } from '../../grid/grid-wrapper';
import { CardWrapper } from '../../card-wrapper';
import { Typography } from '../../typography';
import './grid-view.scss';
import { useNavigate } from 'react-router-dom';
import { createdOnAndBy } from '../../../utils/common';

interface IGridCard {
	data: any[];
	config?: any;
}

const GridCard: React.FC<IGridCard> = ({ data, config }) => {
	const navigate = useNavigate();
	const currentModule = location.pathname.split('/')[2];
	
	const moduleConfig = config?.[currentModule] || { filterName: '', redirectionPath: '' };
	const path = `/dashboard/${currentModule}${moduleConfig.redirectionPath}`;

	const handleRedirection = (form: any) => {
		navigate(path, {
			state: { form }
		});
	};

	const formatText = (text: string) => {
		return text?.split('_')?.map(i => i?.charAt(0).toUpperCase() + i?.slice(1).toLowerCase())?.join(' ');
	};

	return (
		<GridWrapper data={data}>
			{data.map((form, index) => (
				<CardWrapper key={form?._id || index}>
					<div className='gridView--CardHeader'>
						<div
							className='gridView--redirection'
							onClick={() => handleRedirection(form)}>
							<Typography type='s3' weight='medium' color='theme.secondary.900'>
								{formatText(form?.name)}
							</Typography>
						</div>
					</div>
					<div
						className='gridView--redirection'
						onClick={() => handleRedirection(form)}>
						<Typography type='s3' weight='medium' color='theme.secondary.900'>
							{form?.fields?.filter(
								(field: { is_system_field: boolean }) => !field.is_system_field,
							).length || 0}
						</Typography>
						
						{form?.description && (
							<Typography type='s4' weight='medium' color={'inherit'}>
								{formatText(form?.description)}
							</Typography>
						)}

						<div className='gridView--CardBottom'>
							<Typography type='s5' color='theme.secondary.600'>
								{createdOnAndBy(form)}
							</Typography>
						</div>
					</div>
				</CardWrapper>
			))}
		</GridWrapper>
	);
};

export default GridCard;
